module.exports = __webpack_public_path__ + "entry-150bfe9b/sarah-baudzus.256x256-f42ecc1f33bf544c3aba25b758999a49.webp";